import AuthService from '../service/authService';
import RequestService from '../service/requestService';
import { GlobalLogoutManager } from '@signanthealth/frontend-utilities';
import { generateTracingIdCookie } from 'tc-client-common/dist/utils/api-utils';
let config = require('../config/' + process.env.NODE_ENV);

const getRootDomain = (isCookieOptions) => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const isIpAddress = /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname);

  if (parts.length < 2 || isIpAddress) {
    return hostname;
  }
  if (isCookieOptions) {
    console.log('Using COOKIE_OPTIONS');
    return parts.reverse().splice(0, 2).reverse().join('.');
  }
  console.log('USING TOKEN_COOKIE_OPTIONS');
  return parts.slice(1).join('.');
};

// IMPORTANT: for 'SH-Session cookie the domain MUST be 'signanthealth.com' or 'signanthealth.dev' !
export const COOKIE_OPTIONS = {
  path: '/',
  domain: getRootDomain(true),
  maxAge: 60 * 60 * 24 * 400, // 400 days in seconds
  secure: true,
  sameSite: 'Lax'
};

// will return 'app.dev.ecoa.signanthealth.dev' for planets
// todo: check if this is ok, or do we want domain to be 'signanthealth.dev'
export const TOKEN_COOKIE_OPTIONS = {
  path: '/',
  domain: getRootDomain(false),
  maxAge: 60 * 60 * 24 * 400, // 400 days in seconds
  secure: true,
  sameSite: 'Lax'
};

export const cookieUtilsRead = (name) => {
  const cookie = document.cookie.match(`(^|[^;]+)\\s*${name}\\s*=\\s*([^;]+)`);

  return cookie ? cookie.pop() : '';
};

const readCookie = (cookieName) => {
  const cookie = cookieUtilsRead(cookieName);

  try {
    return cookie ? JSON.parse(cookie) : null;
  } catch {
    return null;
  }
};

export const cookieUtilsWrite = (name, value, options) => {
  const segments = [`${name}=${value}`];

  if (options.domain) {
    segments.push(`domain=${options.domain}`);
  }

  if (options.path) {
    segments.push(`path=${options.path}`);
  }

  if (typeof options.maxAge === 'number') {
    segments.push(`max-age=${options.maxAge}`);
  }

  if (options.secure) {
    segments.push('Secure');
  }

  if (options.sameSite) {
    segments.push(`SameSite=${options.sameSite}`);
  }

  document.cookie = segments.join('; ');
};

export const writeCookie = (cookie, cookieName) => {
  const previousCookieValue = readCookie(cookieName);
  const newCookieValue = { ...previousCookieValue, ...cookie };

  const valueString = JSON.stringify(newCookieValue);

  cookieUtilsWrite(cookieName, valueString, COOKIE_OPTIONS);
};

const cookieUtilsRemove = (name, options) => {
  cookieUtilsWrite(name, '', { ...options, maxAge: 0 });
};

export const deleteCookie = (cookieName, cookieOptions) => {
  if (!cookieOptions) {
    cookieOptions = COOKIE_OPTIONS;
  }
  cookieUtilsRemove(cookieName, {
    domain: cookieOptions.domain,
    path: cookieOptions.path,
    secure: cookieOptions.secure,
    sameSite: cookieOptions.sameSite
  });
};

export const handleTracingCookie = () => {
  const { tracingId } = generateTracingIdCookie('tc_trace_id');
  cookieUtilsWrite('tc_trace_id', tracingId, { ...COOKIE_OPTIONS, maxAge: 60 * 60 * 24 });
};

export const handleRefreshCookie = (expTime = 0, userId) => {
  const savedTimeoutId = localStorage.getItem('refreshTimeoutId');

  if (savedTimeoutId || !expTime || !userId) {
    return;
  }

  const TOKEN_REFRESH_TIMEOUT = config.tokenRefreshTimeout;
  const expirationTime = expTime * 1000;
  const timeLeftUntilRefresh = expirationTime - Date.now() - 30 * 10 ** 3; // 30 sec before token expiration

  if (timeLeftUntilRefresh < 0) {
    return;
  }

  const timeoutId = setTimeout(async () => {
    localStorage.removeItem('refreshTimeoutId');
    try {
      RequestService.deleteQlikSession();
      await AuthService.refreshTokens();
      RequestService.setQlikSession(userId);
    } catch (err) {
      console.log('error on refresh tokens::', err);
    }
    handleRefreshCookie(expTime + TOKEN_REFRESH_TIMEOUT, userId);
    clearTimeout(timeoutId);
  }, timeLeftUntilRefresh);
  localStorage.setItem('refreshTimeoutId', timeoutId);

  return timeoutId;
};

export const setupFakeCookie = () => {
  let email = '';
  const cookieObj = { user: email, lastActivityTimestamp: Date.now() };
  writeCookie(cookieObj, 'SH-Session');
};

export const clearStorage = () => {
  const savedTimeoutId = localStorage.getItem('refreshTimeoutId');
  if (savedTimeoutId) {
    localStorage.removeItem('refreshTimeoutId');
    clearTimeout(savedTimeoutId);
  }
};

export const setupGlobalLogoutManager = (email, signOut = () => {}) => {
  const isLoggedIndicator = cookieUtilsRead('authenticated');
  const isSessionCookieSet = cookieUtilsRead('SH-Session');
  if (isLoggedIndicator && !email && !isSessionCookieSet) {
    // this cookie prevents the infinite reload
    setupFakeCookie();
  }

  if (isLoggedIndicator && email && !GlobalLogoutManager.isSetup()) {
    GlobalLogoutManager.setup({
      // Email address of the user
      userEmail: email,

      // Callback when Global Logout is triggered.
      // This callback should implement the Okta SDK signOut() method.
      onGlobalLogout: () => {
        signOut(); // called e.g. after 15 min of inactivity
      },
      onTimeoutWarning: (logoutTimestampParam) => {}
    });

    GlobalLogoutManager.createCookie();
    GlobalLogoutManager.startPolling();
  }
};
